// Local dependencies
import { ResetError } from '../../../../common/types/reset-error';
import {
  CloseSuccessPopup,
  CreateCategory,
  CreateCategoryActionType,
  CreateCategoryError,
  CreateCategoryInput,
  CreateCategorySuccess,
} from './types';

export function createCategory(input: CreateCategoryInput): CreateCategory {
  return {
    type: CreateCategoryActionType.CREATE_CATEGORY,
    input,
  };
}

export function createCategorySuccess(): CreateCategorySuccess {
  return {
    type: CreateCategoryActionType.CREATE_CATEGORY_SUCCESS,
  };
}

export function createCategoryError(error: Error): CreateCategoryError {
  return {
    type: CreateCategoryActionType.CREATE_CATEGORY_ERROR,
    error,
  };
}

export function closeSuccessPopup(): CloseSuccessPopup {
  return {
    type: CreateCategoryActionType.CLOSE_SUCCESS_POPUP,
  };
}

export function resetError(): ResetError<CreateCategoryActionType.RESET_ERROR> {
  return {
    type: CreateCategoryActionType.RESET_ERROR,
  };
}
